import type { Ref } from 'vue';
import { useQuery } from '@tanstack/vue-query';

import { Sentry } from '@shared/sentry';
import { Analytics } from '@shared/analytics';
import { vueQueryLib } from '@shared/lib/vue-query-lib';

import { DatesPickerApi } from '../api';
import { analyticsEvents } from '../config';

export const useCalendarQuery = (
  countryToId: Ref<number>,
  townFromId: Ref<number>,
) => {
  const calendarQuery = useQuery({
    queryKey: ['calendar-query', countryToId, townFromId],
    queryFn: async () => {
      const response = await DatesPickerApi.getCalendarDates(
        countryToId.value,
        townFromId.value,
      );
      return response.data;
    },
    staleTime: Infinity, // Static data from admin, so it can't become obsolete during a user session
    refetchOnWindowFocus: false,
  });

  vueQueryLib.withOnSuccess({
    query: calendarQuery,
    onSuccess() {
      Analytics.logEvent({
        event: analyticsEvents.CALENDAR_SUCCESS,
      });
    },
  });

  vueQueryLib.withOnError({
    query: calendarQuery,
    onError(error) {
      Analytics.logEvent({
        event: analyticsEvents.CALENDAR_ERROR,
      });

      Sentry.captureExWithCause('ERR_FAILED_TO_FETCH_CALENDAR_DATES', {
        cause: error,
      });
    },
  });

  return calendarQuery;
};
